

import { useEffect, useRef } from 'react';
import { useWebSocketContext } from '@/contexts/WebSocketContext';

export function useWebSocket(eventFilter = [], { onMessage } = {}) {
  const { addListener, status } = useWebSocketContext();
  const onMessageRef = useRef(onMessage);
  const eventFilterRef = useRef(eventFilter);

  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    eventFilterRef.current = eventFilter;
  }, [eventFilter]);

  useEffect(() => {
    const removeListener = addListener((message) => {
      const event = message?.event;
      if (!event) return;

      const filter = eventFilterRef.current;
      if (filter.length > 0 && !filter.includes(event)) return;

      onMessageRef.current?.(message);
    });

    return removeListener;
  }, [addListener]);

  return { status };
}
